import EditIcon from "@mui/icons-material/Edit";
import { IconButton, Stack, Tooltip, Typography, Zoom } from "@mui/material";

import { ShipmentDetailTitle } from "../ShipmentDetailTitle";

interface Props {
  shipment: ShipperCondensedShipment | undefined;
  onOpenTextBox: VoidFunction;
  textBoxDialog: React.ReactNode;
}

export function EditableShipmentDetailTitle(props: Props) {
  const { shipment, onOpenTextBox, textBoxDialog } = props;

  const getShipmentTitleNode = () => {
    if (!shipment) {
      return <Typography variant="h5">Shipment -</Typography>;
    }
    if (shipment.custom_name != null) {
      let shipmentNoun = "Shipment";
      if (shipment?.info?.type === "MULTI_SHIPMENT_PROJECT") {
        shipmentNoun = "Project";
      }
      return (
        <Tooltip
          title={`${shipmentNoun} ${shipment?.info?.id ?? "-"}`}
          placement="right"
          TransitionComponent={Zoom}
        >
          <Typography
            variant="h5"
            sx={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "100%",
            }}
          >
            {shipment.custom_name}
          </Typography>
        </Tooltip>
      );
    }
    return <ShipmentDetailTitle shipment={shipment} />;
  };

  /*
    minWidth 0 on both stacks lets the title shrink below its text width, which
    is what makes the ellipsis above engage. Without it a flex item's automatic
    minimum size floors the stack at the full width of the (nowrap) custom name,
    and a long name overflows into the progress stepper beside it.
  */
  return (
    <Stack direction="column" sx={{ minWidth: 0 }}>
      <Stack direction="row" sx={{ minWidth: 0 }}>
        {getShipmentTitleNode()}
        <Tooltip
          followCursor
          title="Edit Custom Name"
          placement="right"
          TransitionComponent={Zoom}
        >
          <IconButton
            color="primary"
            onClick={onOpenTextBox}
            sx={{ flexShrink: 0 }}
          >
            <EditIcon fontSize="medium" />
          </IconButton>
        </Tooltip>
        {textBoxDialog}
      </Stack>
      {shipment?.custom_name != null && (
        <Typography variant="h6">
          Shipment {shipment?.info?.id ?? "-"}
        </Typography>
      )}
    </Stack>
  );
}
